const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const parseResponse = async (res) => {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const payload = await res.json();
      detail = payload?.detail || detail;
    } catch (_e) {
      // ignore
    }
    throw new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
  }
  return res.json();
};

const request = async (path, init = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init.headers || {}),
    },
  });
  return parseResponse(response);
};

export const fetchRecoveryRolloutReadiness = (targetMode = null) => {
  const suffix = targetMode ? `?target_mode=${encodeURIComponent(targetMode)}` : '';
  return request(`/api/monitoring/recovery/rollout/readiness${suffix}`);
};

export const fetchRecoveryRolloutChecklist = ({ checklistType = 'pre', targetMode = null } = {}) => {
  const params = new URLSearchParams();
  params.set('checklist_type', checklistType);
  if (targetMode) params.set('target_mode', targetMode);
  return request(`/api/monitoring/recovery/rollout/checklist?${params.toString()}`);
};

export const fetchRecoveryRolloutBlockers = (targetMode) =>
  request(`/api/monitoring/recovery/rollout/blockers?target_mode=${encodeURIComponent(targetMode)}`);

export const fetchRecoveryRollbackRecommendation = () =>
  request('/api/monitoring/recovery/rollout/rollback-recommendation');

export const fetchRecoveryRolloutTransitionExamples = () =>
  request('/api/monitoring/recovery/rollout/transition-examples');

export const validateRecoveryTransition = (payload) =>
  request('/api/monitoring/recovery/rollout/validate-transition', {
    method: 'POST',
    body: JSON.stringify(payload || {}),
  });

export const changeRecoveryRolloutMode = (payload) =>
  request('/api/monitoring/recovery/rollout/change-mode', {
    method: 'POST',
    body: JSON.stringify(payload || {}),
  });

export const fetchRecoveryControlCenterOverview = () =>
  request('/api/monitoring/recovery/control-center/overview');

export const fetchRecoveryControlCenterMismatches = () =>
  request('/api/monitoring/recovery/control-center/mismatches');

export const fetchRecoveryControlCenterPerformance = () =>
  request('/api/monitoring/recovery/control-center/performance');

export const fetchRecoveryShadowSummary = () =>
  request('/api/monitoring/recovery/shadow/summary');
